const mutations = {
  GET_PRODUTOSSELECIONADOS(state) {
    return state.produtosSelecionados;
  },

  GET_PAUTASELECIONADA(state) {
    return state.pautaSelecionada;
  },

  GET_PRODUTOSREFERENCIACAO(state) {
    return state.produtosReferenciacao;
  },

  SET_PRODUTOSSELECIONADOS(state, produtosSelecionados) {
    state.produtosSelecionados = produtosSelecionados;
  },

  SET_PAUTASELECIONADA(state, pautaSelecionada) {
    state.pautaSelecionada = pautaSelecionada;
  },

  SET_PRODUTOSREFERENCIACAO(state, produtosReferenciacao) {
    state.produtosReferenciacao = produtosReferenciacao;
  },
};

export default mutations;
